import { render, staticRenderFns } from "./CreateGeneralKasbonMultiPerEmployee.vue?vue&type=template&id=6f95cf7c"
import script from "./CreateGeneralKasbonMultiPerEmployee.vue?vue&type=script&lang=js"
export * from "./CreateGeneralKasbonMultiPerEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports